import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRequestModels } from '@share-models';
import { api } from '../consts/url';

@Injectable({ providedIn: 'root' })
export class PanicHttpRequestService {
  private readonly http = inject(HttpClient);

  public getAll(): Observable<HttpRequestModels.Document[]> {
    return this.http.get<HttpRequestModels.Document[]>(api.httpRequests.all);
  }

  public create(
    body: HttpRequestModels.CreateDto,
  ): Observable<HttpRequestModels.Document> {
    return this.http.post<HttpRequestModels.Document>(
      api.httpRequests.create,
      body,
    );
  }

  public update(
    id: string,
    body: HttpRequestModels.UpdateDto,
  ): Observable<boolean> {
    return this.http.put<boolean>(api.httpRequests.update(id), body);
  }

  public setEnabled(id: string, enabled: boolean): Observable<boolean> {
    return this.http.patch<boolean>(api.httpRequests.setEnabled(id), {
      enabled,
    });
  }

  public delete(id: string): Observable<HttpRequestModels.Document> {
    return this.http.delete<HttpRequestModels.Document>(
      api.httpRequests.delete(id),
    );
  }
}
